import ApiService from "./MainServices";
import StorageService from "./StorageService";
import Dashboard from "../components/Dashboard";

const serviceApi = process.env.REACT_APP_SERVICE_URL;

const storageService = new StorageService();
const apiService = new ApiService();

export const API = {
  getServices: serviceApi + "/v1/transcript/navigo/services",
  createAppointment: serviceApi + "/v1/transcript/navigo/create",
  getSlots: serviceApi + "/v1/transcript/navigo/getslots",
  getServiceById: serviceApi + "/v1/navigo/service/{0}",
};

const header = {
  "Content-Type": "application/json",
  auth_token: storageService.get("token"),
  phone_no: storageService.get("phone_no"),
  client: "bridge_web", // Since no payment is required
};

// const getSlotsBody = {
//   // patientId:
// }

class NavigoService {
  constructor() {}
  getServices(onResponse: any, onError: any) {
    let url = API.getServices;
    return apiService.get(
      url,
      header,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onResponse([]);
      },
    );
  }

  getServiceById(id: number, onResponse: any, onError: any) {
    // let url = API.getServiceById.replace('{0}', id);
    let url = serviceApi + `/v1/transcript/navigo/service/${id}`;
    return apiService.get(
      url,
      header,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onResponse([]);
      },
    );
  }

  createAppointment(appointment: any, onResponse: any, onError: any) {
    let url = API.createAppointment;
    return apiService.post(
      url,
      header,
      appointment,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onError(error);
      },
    );
  }

  // type SlotRequest struct {
  //   PatientID      int64  `json:"patientId"`
  //   ServiceID      int64  `json:"serviceId"`
  //   CollectionDate string `json:"collectionDate"`
  //   Pincode        int64  `json:"pincode"`
  //   Email          string `json:"email"`
  //   AddressId      int64  `json:"addressId"`
  //   Vendor         string `json:"vendor"`
  //   VendorCode     string `json:"vendorCode"`
  // }

  getSlots(
    // date: string,
    // serviceId: number,
    // email: string,
    patientId: number,
    selectedServiceId: number | undefined,
    collectionDate: string,
    pincode: string,
    addressId: number,
    email: string = "",
    vendor: "",
    onResponse: any,
    onError: any,
  ) {
    let url = `${API.getSlots}?pid=${patientId}&sid=${selectedServiceId}&date=${collectionDate}&pincode=${pincode}&aid=${addressId}&email=${email}`;
    return apiService.get(
      url,
      header,
      // getSlotsBody,
      (response: any) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error: any) => {
        onResponse([]);
      },
    );
  }
}

export default NavigoService;
